@if ((loading$ | async) === false) {
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="document.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            @if (errors?.name) {
              <small class="p-error">
                {{ errors.name | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Файл</label>
            @if (document?.file?.name) {
              <div class="mb-3">
                <crm-file [file]="document.file"></crm-file>
              </div>
            }
            <crm-file-uploader
              (filesUploaded)="setFile($event)"
              label="Файл"></crm-file-uploader>
            @if (errors?.file) {
              <small class="p-error">
                {{ errors.file | join }}
              </small>
            }
          </div>
        </div>
      </p-card>

      @if (formStoreService.getState.forms[this.index]?.isEdit) {
        <div class="mt-3">
          <crm-document-file-template-logs [documentId]="document.id"></crm-document-file-template-logs>
        </div>
      }
    </div>
  </div>

  @if ((form$ | async)?.canWrite) {
    <div class="mt-3">
      <div class="flex flex-wrap justify-content-between">
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success"
          (onClick)="saveDocument()"></crm-button>
        <div class="flex align-items-center gap-2">
          @if ((form$ | async)?.isShowDelete && !document.deleted) {
            <crm-button
              label="Удалить"
              styleClass="p-button-danger p-button-text"
              (onClick)="deleteDocument()"></crm-button>
          } @else if ((form$ | async)?.isShowDelete && document.deleted) {
            <crm-button
              icon="pi pi-undo"
              label="Восстановить"
              styleClass="p-button-info p-button-text"
              (onClick)="restoreDocument()"></crm-button>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
